import { render, staticRenderFns } from "./lib-ref-group.vue?vue&type=template&id=ead3a3c8&scoped=true"
import script from "./lib-ref-group.vue?vue&type=script&lang=ts"
export * from "./lib-ref-group.vue?vue&type=script&lang=ts"
import style0 from "./lib-ref-group.vue?vue&type=style&index=0&id=ead3a3c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead3a3c8",
  null
  
)

export default component.exports